import React from "react";

import { DSProvider } from "@toddle-edu/ds-web";

import AssessmentGradeScaleToolEdit from "./components/AssessmentGradeScaleToolEdit";
import AssessmentGradeScaleToolView from "./components/AssessmentGradeScaleToolView";

const AssessmentGradeScaleTool = props => {
  const {
    mode = "edit",
    testId = "appComponents-assessmentGradeScaleTool",
  } = props;

  let component = null;

  switch (mode) {
    case "create":
    case "edit":
      component = <AssessmentGradeScaleToolEdit {...props} testId={testId} />;
      break;
    case "view":
      component = <AssessmentGradeScaleToolView {...props} testId={testId} />;
      break;
  }

  return <DSProvider dsVersion="2.0">{component}</DSProvider>;
};

export default AssessmentGradeScaleTool;
